import axios, { AxiosProgressEvent } from "axios";
import useCurrentLocale from "../../../Composables/current-locale";

export type FileUploadResponse = {
    success: number;
    data: {
        link: string;
        name: string;
        file_name: string;
        file_type: string;
    };
    messages?: string[];
};

export type UploadedFile = {
    file: File;
    url: string;
    progress?: AxiosProgressEvent;
};

export const useFileUploader = (fieldId: number) => {
    const { urlWithLocale } = useCurrentLocale();

    const upload = async (file: File, onUploadProgress: (progressEvent: AxiosProgressEvent) => void) => {
        const formData = new FormData();
        formData.append('ajax', 'ajax-field-upload-file');
        formData.append('fieldId', fieldId.toString());
        formData.append('file', file);
    
        return axios.post<FileUploadResponse>(urlWithLocale.value('/:locale/'), formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress
        });
    }

    return {
        upload
    };
};